<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import api from "@/axios";
import { getBaseUrl } from "@/helpers/baseUrl";

function hoje() {
  return new Date().toISOString().slice(0, 10);
}
function ha30Dias() {
  return new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export default {
  components: { Layout, PageHeader },

  page: {
    title: "Mensagens WA",
    meta: [{ name: "description", content: "Conversas WhatsApp" }],
  },

  data() {
    return {
      title: "Mensagens WA",
      items: [{ text: "WhatsApp", href: "/wsapi/whatsapp" }, { text: "Mensagens", active: true }],

      contatos: [],
      loading: false,
      total: 0,
      page: 1,
      perPage: 25,
      perPageOptions: [10, 25, 50, 100],

      dtIniFiltro: ha30Dias(),
      dtFimFiltro: hoje(),

      modalAberto: false,
      contatoSelecionado: null,
      mensagens: [],
      loadingMsgs: false,
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage) || 1;
    },
    paginasVisiveis() {
      const delta = 2;
      const range = [];
      for (
        let i = Math.max(1, this.page - delta);
        i <= Math.min(this.totalPages, this.page + delta);
        i++
      ) {
        range.push(i);
      }
      return range;
    },
  },

  mounted() {
    this.carregarContatos();
  },

  methods: {
    carregarContatos() {
      this.loading = true;
      api
        .get(`${getBaseUrl()}api/wsapi/conversas`, {
          params: {
            di: this.dtIniFiltro,
            df: this.dtFimFiltro,
            page: this.page,
            per_page: this.perPage,
          },
        })
        .then((res) => {
          this.contatos = res.data.data || [];
          this.total    = res.data.total || 0;
        })
        .catch(() => {
          this.contatos = [];
          this.total    = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    filtrar() {
      this.page = 1;
      this.carregarContatos();
    },

    limparFiltro() {
      this.dtIniFiltro = ha30Dias();
      this.dtFimFiltro = hoje();
      this.page        = 1;
      this.carregarContatos();
    },

    irPara(p) {
      if (p >= 1 && p <= this.totalPages) {
        this.page = p;
        this.carregarContatos();
      }
    },

    abrirChat(contato) {
      this.contatoSelecionado = contato;
      this.mensagens = [];
      this.modalAberto = true;
      this.carregarMensagens();
    },

    fecharModal() {
      this.modalAberto = false;
      this.contatoSelecionado = null;
      this.mensagens = [];
    },

    carregarMensagens() {
      this.loadingMsgs = true;
      const params = this.contatoSelecionado.is_group
        ? { chat_id: this.contatoSelecionado.chat_id }
        : { contact_phone: this.contatoSelecionado.contact_phone };
      api
        .get(`${getBaseUrl()}api/wsapi/conversas/mensagens`, { params })
        .then((res) => {
          this.mensagens = res.data || [];
        })
        .catch(() => {
          this.mensagens = [];
        })
        .finally(() => {
          this.loadingMsgs = false;
          this.$nextTick(() => this.rolarParaBaixo());
        });
    },

    rolarParaBaixo() {
      const el = this.$refs.chatBody;
      if (el) el.scrollTop = el.scrollHeight;
    },

    formatarTelefone(phone) {
      if (!phone) return "—";
      const d = String(phone).replace(/\D/g, "");
      if (d.length === 13) {
        return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 5)} ${d.slice(5, 9)}-${d.slice(9)}`;
      }
      if (d.length === 12) {
        return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 8)}-${d.slice(8)}`;
      }
      return phone;
    },

    formatarGrupo(chatId) {
      if (!chatId) return "Grupo";
      const id = chatId.replace(/@.*/, "");
      const parts = id.split("-");
      // formato "552798...-timestamp@g.us" → pega o prefixo (número de telefone)
      const base = parts.length > 1 ? parts[0] : id;
      return `Grupo (...${base.slice(-6)})`;
    },

    nomeConversa(c) {
      if (c.is_group) return this.formatarGrupo(c.chat_id);
      return this.formatarTelefone(c.contact_phone);
    },

    formatarDataHora(iso) {
      if (!iso) return "—";
      try {
        return new Date(iso).toLocaleString("pt-BR", {
          day: "2-digit", month: "2-digit", year: "numeric",
          hour: "2-digit", minute: "2-digit",
        });
      } catch {
        return iso;
      }
    },

    formatarHora(iso) {
      if (!iso) return "";
      try {
        return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
      } catch {
        return "";
      }
    },

    truncar(texto, n = 60) {
      if (!texto) return "—";
      return texto.length > n ? texto.slice(0, n) + "…" : texto;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span><i class="mdi mdi-whatsapp me-2 text-success"></i> Conversas</span>
        <button class="btn btn-outline-secondary btn-sm" @click="carregarContatos" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="mdi mdi-refresh me-1"></i> Atualizar
        </button>
      </div>

      <!-- Barra de filtros -->
      <div class="card-body border-bottom py-2">
        <div class="row g-2 align-items-end">
          <div class="col-auto">
            <label class="form-label mb-1" style="font-size:12px;">Data início</label>
            <input type="date" class="form-control form-control-sm" v-model="dtIniFiltro" />
          </div>
          <div class="col-auto">
            <label class="form-label mb-1" style="font-size:12px;">Data fim</label>
            <input type="date" class="form-control form-control-sm" v-model="dtFimFiltro" />
          </div>
          <div class="col-auto">
            <button class="btn btn-success btn-sm" @click="filtrar" :disabled="loading">
              <i class="mdi mdi-filter me-1"></i> Filtrar
            </button>
            <button class="btn btn-outline-secondary btn-sm ms-1" @click="limparFiltro" :disabled="loading">
              Limpar
            </button>
          </div>
          <div class="col-auto ms-auto d-flex align-items-end gap-2">
            <div>
              <label class="form-label mb-1" style="font-size:12px;">Por página</label>
              <select class="form-select form-select-sm" v-model="perPage" @change="filtrar" style="width:90px;">
                <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <div v-if="loading" class="text-center py-4">
          <div class="spinner-border text-success" role="status"></div>
        </div>

        <div v-else-if="contatos.length === 0" class="text-center py-4 text-muted">
          <i class="mdi mdi-message-off font-size-24"></i>
          <p class="mt-2">Nenhuma conversa encontrada.</p>
        </div>

        <div v-else>
          <p class="text-muted px-3 pt-2 mb-0" style="font-size: 12px;">
            Duplo-clique em uma linha para ver o histórico de mensagens.
          </p>
          <table class="table table-hover table-striped align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>Conversa</th>
                <th>Última mensagem</th>
                <th style="white-space:nowrap;">Data/Hora</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="c in contatos"
                :key="c.is_group ? c.chat_id : c.contact_phone"
                @dblclick="abrirChat(c)"
                style="cursor: pointer;"
              >
                <td>
                  <i
                    class="mdi me-1"
                    :class="c.is_group
                      ? 'mdi-account-group text-warning'
                      : 'mdi-whatsapp text-success'"
                    :title="c.is_group ? 'Grupo' : 'Conversa privada'"
                  ></i>
                  {{ nomeConversa(c) }}
                </td>
                <td class="text-muted" style="max-width: 320px;">
                  <i
                    class="mdi me-1"
                    :class="c.is_me ? 'mdi-arrow-up-bold text-success' : 'mdi-arrow-down-bold text-primary'"
                    :title="c.is_me ? 'Enviada por nós' : 'Recebida'"
                  ></i>
                  {{ truncar(c.ultima_msg) }}
                </td>
                <td style="white-space:nowrap; font-size:13px;">
                  {{ formatarDataHora(c.received_at) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Rodapé: total + paginação -->
      <div class="d-flex justify-content-between align-items-center px-3 py-2 border-top">
        <span class="text-muted" style="font-size:13px;">
          {{ total }} conversa(s) encontrada(s)
        </span>
        <nav v-if="totalPages > 1" aria-label="Paginação">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="irPara(page - 1)">‹</button>
            </li>
            <li v-if="paginasVisiveis[0] > 1" class="page-item disabled">
              <span class="page-link">1</span>
            </li>
            <li v-if="paginasVisiveis[0] > 2" class="page-item disabled">
              <span class="page-link">…</span>
            </li>
            <li
              v-for="p in paginasVisiveis"
              :key="p"
              class="page-item"
              :class="{ active: p === page }"
            >
              <button class="page-link" @click="irPara(p)">{{ p }}</button>
            </li>
            <li v-if="paginasVisiveis[paginasVisiveis.length - 1] < totalPages - 1" class="page-item disabled">
              <span class="page-link">…</span>
            </li>
            <li v-if="paginasVisiveis[paginasVisiveis.length - 1] < totalPages" class="page-item disabled">
              <span class="page-link">{{ totalPages }}</span>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="irPara(page + 1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Modal de chat -->
    <div
      v-if="modalAberto && contatoSelecionado"
      class="modal d-block"
      tabindex="-1"
      style="background:rgba(0,0,0,.4);"
      @click.self="fecharModal"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">
              <i
                class="mdi me-2"
                :class="contatoSelecionado.is_group
                  ? 'mdi-account-group text-warning'
                  : 'mdi-whatsapp text-success'"
              ></i>
              {{ nomeConversa(contatoSelecionado) }}
            </h5>
            <button type="button" class="btn-close" @click="fecharModal"></button>
          </div>

          <div
            class="modal-body"
            ref="chatBody"
            style="height: 460px; overflow-y: auto; background: #f0f2f5;"
          >
            <div v-if="loadingMsgs" class="text-center py-4">
              <div class="spinner-border text-success" role="status"></div>
            </div>

            <div v-else-if="mensagens.length === 0" class="text-center py-4 text-muted">
              Nenhuma mensagem encontrada.
            </div>

            <div v-else class="d-flex flex-column gap-2 px-2 py-2">
              <div
                v-for="(msg, i) in mensagens"
                :key="msg.message_id || i"
                class="d-flex"
                :class="msg.is_me ? 'justify-content-end' : 'justify-content-start'"
              >
                <div
                  class="rounded px-3 py-2 shadow-sm"
                  style="max-width: 75%; word-break: break-word; font-size: 14px;"
                  :style="msg.is_me ? 'background: #d9fdd3;' : 'background: #ffffff;'"
                >
                  <!-- Remetente em grupos não-próprios -->
                  <div
                    v-if="contatoSelecionado.is_group && !msg.is_me && msg.sender_phone"
                    style="font-size: 11px; font-weight: 600; color: #075e54; margin-bottom: 2px;"
                  >
                    {{ formatarTelefone(msg.sender_phone) }}
                  </div>
                  <div>{{ msg.text || `[${msg.type}]` }}</div>
                  <div class="text-end mt-1" style="font-size: 11px; color: #999;">
                    {{ formatarHora(msg.received_at) }}
                    <i
                      v-if="msg.is_me"
                      class="mdi ms-1"
                      :class="{
                        'mdi-check': msg.status === 'sent',
                        'mdi-check-all': msg.status === 'delivered',
                        'mdi-check-all text-primary': msg.status === 'read',
                      }"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fecharModal">Fechar</button>
          </div>

        </div>
      </div>
    </div>

  </Layout>
</template>
